import { IScenarioBuildStatus } from '../../interfaces/iscenario-build-status';
import { Scenario } from '../scenario';
import { ScenarioBuildStatusType } from '../scenario-build-status-type';

export class ScenarioBuildStatusBase {
  ScenarioBuildStatusId: number;
  ScenarioId: number;
  BuildStart: Date;
  BuildEnded: Date | null;
  StartedByUID: string;
  ScenarioBuildStatusTypeId: number;
  ProgressPercent: number;
  CancelledByUID: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ScenarioBuildStatusType?: ScenarioBuildStatusType;
  Scenario?: Scenario;

  constructor(item?: IScenarioBuildStatus) {
    if (item) {

      this.ScenarioBuildStatusId = item.ScenarioBuildStatusId;
      this.ScenarioId = item.ScenarioId;
      this.BuildStart = item.BuildStart ? new Date(item.BuildStart) : null;
      this.BuildEnded = item.BuildEnded ? new Date(item.BuildEnded) : null;
      this.StartedByUID = item.StartedByUID;
      this.ScenarioBuildStatusTypeId = item.ScenarioBuildStatusTypeId;
      this.ProgressPercent = item.ProgressPercent;
      this.CancelledByUID = item.CancelledByUID;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ScenarioBuildStatusType = new ScenarioBuildStatusType(item.ScenarioBuildStatusType);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}